import { render, staticRenderFns } from "./create-review.vue?vue&type=template&id=7c9522a2&"
import script from "./create-review.vue?vue&type=script&lang=ts&"
export * from "./create-review.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports